import { EMPTY, of, OperatorFunction } from 'rxjs';
import { concatMap } from 'rxjs/operators';

export function isOfType<TIn, TOut extends TIn>(
  guard: (v: TIn) => v is TOut,
): OperatorFunction<TIn, TOut> {
  return concatMap((value) => (guard(value) ? of(value) : EMPTY));
}
